export default [
    {
        path: '',
        name: 'layananLainnya',
        component: () => import('./page-layanan-lainnya')
    }
]